/** @jsxImportSource @emotion/react */

import { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { jsx } from '@emotion/react'
import css from '@emotion/css/macro'
import { t } from '@sportninja/common/i18n'
import { withRouter } from 'react-router'

import { Container } from '../../components/Layout'
import { media } from '../../components/Responsive'
import StatisticsTable from '../../components/StatisticsTable'
import { useTabNavigation } from '../../pages/utils'

const TabbedStatisticsContainer = ({
  children,
  hideWhenSingleTab = false,
  fetchData,
  history,
  tabTypes,
  onClick,
  ...props
}) => {
  const defaultTabs = {
    player: {
      key: 'player',
      button: { short: t('common:skater'), long: t('common:skater') },
    },
    goalie: {
      key: 'goalie',
      button: { short: t('common:goalie'), long: t('common:goalie') },
    },
  }

  const tabs = tabTypes || defaultTabs
  const firstTab = Object.keys(tabs)[0]

  const { component: Tabs, selectedTab } = useTabNavigation(
    tabs,
    firstTab,
    history
  )

  useEffect(() => {
    onClick(selectedTab)
  }, [onClick, selectedTab])

  const patchedFetchData = useCallback(
    async (...args) => {
      return await fetchData(selectedTab, ...args)
    },
    [fetchData, selectedTab?.key]
  )

  return (
    <Container
      as='main'
      css={css`
        ${media.mobile} {
          width: 100%;
          padding: 0;
        }
      `}
    >
      <div
        css={css`
          display: flex;
          width: 100%;
          margin: 0 0
            ${hideWhenSingleTab && Object.keys(tabs)?.length === 1 ? 0 : 40}px
            8px;

          ${media.mobile} {
            width: unset;
            margin: 0px 8px 16px 8px;
            justify-content: space-between;
          }

          > div {
            flex-basis: 45%;

            ${media.mobile} {
              flex-basis: ${children ? '50%' : '100%'};
            }

            &:last-of-type:not(:only-child) {
              margin-left: 8px;
            }
          }
        `}
      >
        {children}
        <Tabs hideWhenSingleTab={hideWhenSingleTab} />
      </div>
      <StatisticsTable
        key={selectedTab.key}
        fetchData={patchedFetchData}
        {...props}
      />
    </Container>
  )
}

TabbedStatisticsContainer.propTypes = {
  hideWhenSingleTab: PropTypes.bool,
  onClick: PropTypes.func,
  fetchData: PropTypes.func.isRequired,
  tabTypes: PropTypes.object,
}

export default withRouter(TabbedStatisticsContainer)
